module.exports = __webpack_public_path__ + "static/media/mexican.ea41419b.jpg";